import { render, staticRenderFns } from "./userpic.vue?vue&type=template&id=23e8662b&scoped=true&"
import script from "./userpic.vue?vue&type=script&lang=js&"
export * from "./userpic.vue?vue&type=script&lang=js&"
import style0 from "./userpic.vue?vue&type=style&index=0&id=23e8662b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8662b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e8662b')) {
      api.createRecord('23e8662b', component.options)
    } else {
      api.reload('23e8662b', component.options)
    }
    module.hot.accept("./userpic.vue?vue&type=template&id=23e8662b&scoped=true&", function () {
      api.rerender('23e8662b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/userpic.vue"
export default component.exports